module.exports = __webpack_public_path__ + "static/img/IMG_20240820_203934.fb8ddc1a.jpg";